export default "__VITE_ASSET__d0d29560__"